import { cn } from '@/shadcn/lib/utils';

type Props = {
  tabs: string[];
  value: string;
  loading?: boolean;
  onChange: (tab: string) => void;
};

export const RadioButtonsGroup = ({
  tabs,
  value,
  loading = false,
  onChange
}: Props) => {
  return (
    <div className="border-border relative mr-2 flex shrink-0 items-center overflow-hidden rounded-md border">
      {tabs.map(tab => {
        const tabSelected = value.toLowerCase() === tab.toLowerCase();
        const tabName = tab === 'Custom' ? 'Default' : tab;
        return (
          <button
            className={cn(
              'border-border text-card-foreground cursor-pointer border-r px-4 py-1 text-sm last:border-r-0',
              tabSelected && 'bg-primary text-primary-foreground cursor-default'
            )}
            key={tab}
            disabled={loading || tabSelected}
            onClick={() => onChange(tab)}
            aria-label={`Click to select ${tabName} subscription mode`}
          >
            {tabName}
          </button>
        );
      })}
    </div>
  );
};
